import type { OrgTreeNode } from '../model/organizationSchema';

const KEY = 'ohs-arm-org-tree-override';

export function readOrgTreeOverride(): OrgTreeNode[] | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as OrgTreeNode[];
    return Array.isArray(p) ? p : null;
  } catch {
    return null;
  }
}

export function writeOrgTreeOverride(nodes: OrgTreeNode[]): void {
  localStorage.setItem(KEY, JSON.stringify(nodes));
}
